export default (): any =>{
    let useStyles = (theme: any) => { 
        return {
            list: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100vh',
                borderRight: '1px solid #ccc',
                paddingTop: '25px',
                fontSize:"13px"
            },
            customerList: {
                height: 'calc(100vh - 20px)',
                overflowY: 'auto',
                paddingTop: 0
            },
            customer: {
                textDecoration: 'none',
                color: '#333'
            },
            activeLink: {
                '& .bt': {
                backgroundColor: '#D6ECFF'
                }
            },
            searchNAdd: {
                padding: '10px 10px 0 10px',
                // display: 'grid',
                // gridTemplateColumns: '3fr 1fr',
                // justifyContent: 'space-around'
            },
            addBtn: {
                backgroundColor: '#0079E4',
                flex: 1,
                margin: 'auto',
                color: '#fff',
                width: 30,
                height: 30,
                border: 'unset',
                borderRadius: 5
            },
            customerHeader: {
                display: 'flex',
                color:"#112B42",
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 0 5px 10px',
                margin: '0 5px',

                '& > div > *': {
                    margin: '0 5px'
                }
            }
        }
    }
    return useStyles;
}